export const isDOM = () => typeof window !== 'undefined';

export const isBrowser = () => {
  if (isDOM()) {
    return true;
  }
  return false;
};

export const isDesktop = () => {
  if (isDOM()) {
    return window.innerWidth >= 1024;
  } else {
    return false;
  }
};

export const isTablet = () => {
  if (isDOM()) {
    return window.innerWidth >= 800 && window.innerHeight < 1024;
  } else {
    return false;
  }
};

export const isMobile = () => {
  if (isDOM()) {
    return window.innerWidth < 800;
  } else {
    return false;
  }
};
